import { render, staticRenderFns } from "./FormOtros.vue?vue&type=template&id=094ae745&"
import script from "./FormOtros.vue?vue&type=script&lang=js&"
export * from "./FormOtros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports